import type { PhotoFrameItem } from '@/schemas/v2/spot'
import { memo, useEffect } from 'react'
import { PhotoFrame } from './PhotoFrame'

type Props = {
  photoFrames: PhotoFrameItem[]
  open: boolean
  onClose: () => void
  onSaveSuccess?: () => void
  scrollLock?: boolean
  snsHashtag?: string
}

export const ArPhotoOverlay = memo(({ photoFrames, open, onClose, onSaveSuccess, snsHashtag }: Props) => {
  useEffect(() => {
    if (!open) return
    // オーバーレイ表示時に履歴エントリを追加
    history.pushState({ arPhotoOverlay: true }, '')
    let closedViaPopState = false
    const handlePopState = () => {
      closedViaPopState = true
      onClose()
    }
    window.addEventListener('popstate', handlePopState)
    return () => {
      window.removeEventListener('popstate', handlePopState)
      // popstate 経由でない閉じ方の場合は、push した履歴エントリを戻す
      if (!closedViaPopState && history.state?.arPhotoOverlay) {
        history.back()
      }
    }
  }, [open, onClose])

  if (!open) return null

  return (
    <div className="fixed inset-0 z-[200] flex flex-col">
      <PhotoFrame
        photoFrame={photoFrames}
        snsHashtag={snsHashtag}
        onSaveSuccess={() => {
          onSaveSuccess?.()
          onClose()
        }}
        onClose={() => {
          // × ボタンで閉じる場合は履歴を戻す
          if (history.state?.arPhotoOverlay) {
            history.back()
          } else {
            onClose()
          }
        }}
      />
    </div>
  )
})

ArPhotoOverlay.displayName = 'ArPhotoOverlay'
